import { readQuery } from '@/utils';
import { Currency } from './settings';

export enum Environment {
  Development = 'development',
  Stage = 'stage',
  Production = 'production',
}

export namespace Utils {
  export interface InfoResponse {
    countries: Countries.Response[];
    currencies: CurrencyExchange.Rates;
  }

  export namespace CurrencyExchange {
    export type Pair = Record<Currency.CURRENCIES, number>;

    export type Rates = Pair & {
      base: Currency.CURRENCIES;
      date: string;
      createdAt?: Date;
    };
  }

  export namespace Countries {
    export interface Response {
      name?: string;
      code?: string;
      iso2?: string;
      iso3?: string;
      europe?: boolean;
      phoneLength?: string;
    }

    export class Country {
      name?: string;
      code?: string;
      iso2?: string;
      iso3?: string;
      europe?: boolean;
      phoneLength?: number;

      constructor(country: Response) {
        this.code = country.code;
        this.iso2 = country.iso2;
        this.iso3 = country.iso3;
        this.name = country.name;
        this.phoneLength = country?.phoneLength
          ?.split('|')
          ?.map(it => parseInt(it))
          ?.distinct()
          ?.max();
      }
    }
  }

  export namespace Cobrand {
    const KEY = 'fp_cobrand';

    export enum Params {
      MC = 'mc',
      Anna = 'anna',
      None = 'none',
    }

    export function get(): Params {
      const byQuery = readQuery('cobrand');
      const brand = byQuery ?? localStorage.getItem(KEY);
      if (!brand || !Object.values(Params).includes(brand)) {
        return Params.MC;
      }

      store(brand);
      document.body.classList.add(`cobrand--${brand}`);
      return brand;
    }

    export function store(value: Params) {
      localStorage.setItem(KEY, value);
    }
  }
}
